import reducerGenerator from "../reducerGenerator";
import {SDB_ENABLED_SET, SDB_EXCEPTION_USERS_SET, SDB_MINIMAL_VALUE_SET, SDB_USER_EXCEPTION_TYPE_SET} from "./actionTypes";

const createReducer = ({
    LOW_BALANCE_SETTINGS = {PTO: {}, SDB: {}},
}) => {
    return reducerGenerator({
        actions: {
            ENABLED_SET: SDB_ENABLED_SET,
            MINIMAL_VALUE_SET: SDB_MINIMAL_VALUE_SET,
            EXCEPTION_USERS_SET: SDB_EXCEPTION_USERS_SET,
            USER_EXCEPTION_TYPE_SET: SDB_USER_EXCEPTION_TYPE_SET,
        }, initialState: LOW_BALANCE_SETTINGS.SDB
    })
}

export default createReducer


// WEBPACK FOOTER //
// ./web/js/administration/lowBalanceSettings/sdb/reducer.js